(ns app.front.view.admin.commands.execute-queries
  (:require [app.front.ui :as ui]
            [app.front.util :refer [for-frag]]
            [app.front.view.admin.entity-table :as entable]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.reporting.download-button :as rdb]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-event-fx ::get-queries
  (fn [_ _]
    {:comm/command {:command    :admin/get-queries
                    :method     :get
                    :on-success [::get-queries.success]}}))

(rf/reg-event-db ::get-queries.success
  (fn [db [_ _ available-queries]]
    (-> db
        (assoc-in [::state :queries] available-queries))))

(rf/reg-event-fx ::execute
  (fn [{:keys [db]} [_ query-key]]
    {:db           (-> db
                       (assoc-in [::state :pending] query-key)
                       (update ::state update :results dissoc query-key))
     :comm/command {:command    :admin/execute-query
                    :data       (util/mmap query-key)
                    :on-done    [::execute.done]
                    :on-success [::execute.success query-key]}}))

(rf/reg-event-db ::execute.success
  (fn [db [_ query-key _ {:keys [results]}]]
    (-> db
        (update ::state dissoc :pending)
        (assoc-in [::state :results query-key] results))))

(rf/reg-event-db ::execute.done
  (fn [db _]
    (-> db
        (update ::state dissoc :pending))))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::cannot-start?
  :<- [::state]
  (fn [{:keys [pending]} _]
    (some? pending)))

(rf/reg-sub ::executing?
  :<- [::state]
  (fn [{:keys [pending]} [_ query-key]]
    (= pending query-key)))

(rf/reg-sub ::queries
  :<- [::state]
  :-> :queries)

(rf/reg-sub ::queries-sorted
  :<- [::queries]
  (fn [queries _]
    (->> queries
         (sort-by (comp name first)))))

(rf/reg-sub ::query
  :<- [::queries]
  (fn [queries [_ query-key]]
    (get queries query-key)))

(rf/reg-sub ::results
  :<- [::state]
  (fn [{:keys [results]} [_ query-key]]
    (get results query-key)))

(defn query-link [[query-key {:keys [description]}]]
  [:li.mb-2.p-4.bg-ui-light-gray.rounded-md
   [:a {:href (href/href :view/admin.commands.query.exec (util/mmap query-key))}
    query-key]
   [:div.mt-2 description]])

(defn view [match]
  [acommon/admin-page (util/mmap {:title "Pre-defined queries"} match)
   [:section
    [:h2 "Available queries"]
    [:ul
     (for-frag [q (<sub [::queries-sorted])]
       [query-link q])]]])

(defn result-display-std [col]
  (cond
    (inst? col)
    [entable/format-instant col]
    :else
    [:td.font-mono (str col)]))

(defn result-display [result]
  [:tr
   (for-frag [col result]
     (if (vector? col)
       (case (first col)
         :entity
         [:td>a.font-mono
          {:href (href/href :view/admin.entity-lookup-with-param
                            {:search-term (second col)})}
          (-> col second str)]

         :link
         (let [[_ text route params] col]
           [:a {:href (href/href route params)}
            (str text)])

         [result-display-std col])
       [result-display-std col]))])

(defn view-query [{{{:keys [query-key]} :path} :parameters :as match}]
  (let [{:keys [description cols]} (<sub [::query query-key])
        results                    (<sub [::results query-key])]
    [acommon/admin-page (util/mmap {:title (name query-key)} match)
     [:section
      [ui/help description]
      [:div.flex.gap-3.items-end
       (cc/button {:on-click #(>evt [::execute query-key])
                   :disabled (<sub [::cannot-start?])
                   :size     :field}
                  (str "Execute" (when (seq results) " again")))
       [rdb/download-button
        {:base-url "/api/command/admin/export-query"
         :query    (util/mmap query-key)
         :tr       (<sub [:tr])}]]
      (when (<sub [::executing? query-key])
        (cc/loading-spinner {:with-overlay false}))
      (when (seq results)
        [:div.mt-4
         [:table.w-full
          [:thead>tr.justify-between.mb-2.pb-1.border-b.border-solid
           (for-frag [h cols]
             [:td h])]
          [:tbody
           (for-frag [result results]
             [result-display result])]]])]]))

(def route
  {:name        :view/admin.commands.query
   :view        view
   :controllers [{:start (fn [{}]
                           (>evt [::get-queries]))}]})

(def route-query
  {:name       :view/admin.commands.query.exec
   :view       view-query
   :parameters {:path {:query-key s/Keyword}}})
